import React from 'react';

import { PersonalisationHelperModal } from '../PersonalisationHelperModal';
import { highlightInlineText } from '../../utilities/highlightInlineText';
import { processSlotHeading } from '../../utilities/processSlotHeading';
import { useViewModel } from './useViewModel';

import styles from './personalisation-slot-header.module.css';

/**
 * @param {Object} props
 * @param {Object} props.slot
 * @param {Object} props.processHeading
 * @returns {import('react').JSX.Element}
 */
export default function PersonalisationSlotHeader({ slot, processHeading = true }) {
  const { uiHeading, uiSubheading, helpPage } = slot;
  const { helperModalOpen, setHelperModalOpen } = useViewModel();

  // Process the heading first, then apply highlighting.
  const processedHeading = processSlotHeading({
    headingText: uiHeading,
    shouldAppend: true,
    trimText: '(optional)',
    isRequired: slot.isRequired
  });

  const heading = processHeading ? processedHeading : uiHeading;
  return (
    <div className={styles['personalisation__slot-header']}>
      {(processedHeading || uiSubheading) && (
        <div className={styles['personalisation__slot-description']}>
          {heading && <p className="body-base">{highlightInlineText(heading)}</p>}
          {uiSubheading && <p className="body-sm">{highlightInlineText(uiSubheading)}</p>}
        </div>
      )}

      {helpPage && (
        <>
          <button
            className={styles['personalisation__slot-page-helper'] + ' button-reset'}
            onClick={() => {
              setHelperModalOpen(true);
            }}
          >
            {helpPage?.modalTriggerText?.value || helpPage.title}
          </button>
          <PersonalisationHelperModal
            isOpen={helperModalOpen}
            onClose={() => {
              setHelperModalOpen(false);
            }}
            title={helpPage.title}
          >
            <div className="rte" dangerouslySetInnerHTML={{ __html: helpPage.body }} />
          </PersonalisationHelperModal>
        </>
      )}
    </div>
  );
}
